export default __webpack_public_path__ + "static/media/error_error.9569de3b.png";